module.exports = __webpack_public_path__ + "img/onboarding-image-upload-background.9917a177.png";